// Hardcoded taxonomy — kept in sync with backend `core.py` BODY_PARTS / PRIMARY_MUSCLES.
// Duplicated here so filter pills render before the /api/library/taxonomy fetch resolves.
// The backend endpoint remains the source of truth if the two ever drift.

export const BODY_PARTS = [
  "Legs", "Glutes", "Back", "Chest", "Shoulders",
  "Arms", "Core", "Full Body", "Conditioning",
];

export const PRIMARY_MUSCLES = [
  "quads", "hamstrings", "glutes", "calves",
  "lats", "traps", "rhomboids", "erectors",
  "pecs", "front delts", "side delts", "rear delts",
  "biceps", "triceps", "forearms",
  "core", "obliques", "hip flexors",
  "cardiovascular",
];

// Color hint for the body-part chip on cards. Tailwind classes.
export const BODY_PART_COLOR = {
  Legs:         "bg-terracotta/10 text-terracotta",
  Glutes:       "bg-rose-100 text-rose-800",
  Back:         "bg-sky-100 text-sky-800",
  Chest:        "bg-amber-100 text-amber-800",
  Shoulders:    "bg-violet-100 text-violet-800",
  Arms:         "bg-lime-100 text-lime-800",
  Core:         "bg-orange-100 text-orange-800",
  "Full Body":  "bg-moss/10 text-moss",
  Conditioning: "bg-stone-200 text-stone-800",
};
